export default [
  {
    id: "1",
    name: "base",
    path: "/base",
    title: "基础数据",
    children: [
      {
        id: "101",
        path: "/goods",
        name: "goods",
        title: "商品资料"
      },
      {
        id: "102",
        path: "/goodsclass",
        name: "goodsclass",
        title: "商品分类"
      },
      {
        id: "1001",
        path: "-",
        name: "divider1",
        icon: "",
        title: "-"
      },
      {
        id: "103",
        path: "/employee",
        name: "employee",
        title: "职员资料"
      },
      {
        id: "104",
        path: "/custom",
        name: "custom",
        title: "收货方资料"
      },
      {
        id: "105",
        path: "/supplier",
        name: "supplier",
        title: "供货方资料"
      },
      {
        id: "106",
        path: "/store",
        name: "store",
        title: "仓库设置"
      },
      {
        id: "1000",
        path: "-",
        name: "divider",
        title: "-"
      },
      {
        id: "107",
        path: "/code/color",
        name: "color",
        title: "颜色设置"
      },
      {
        id: "108",
        path: "/code/pinpai",
        name: "pinpai",
        title: "品牌设置"
      },
      {
        id: "109",
        path: "/code/dw",
        name: "dw",
        title: "计量单位"
      },
      {
        id: "110",
        path: "/code/itype",
        name: "itype",
        title: "入库类型"
      },
      {
        id: "111",
        path: "/code/otype",
        name: "otype",
        title: "出库类型"
      },
      {
        id: "112",
        path: "/code/kg",
        name: "kg",
        title: "规格型号"
      },
      {
        id: "113",
        path: "/code/moneytype",
        name: "moneytype",
        title: "结算方式"
      }

    ]
  },
  {
    id: "2",
    name: "iobill",
    path: "/iobill",
    title: "库存管理",
    children: [
      {
        id: "201",
        name: "outbill",
        path: "/outbill",
        title: "出库单管理",
      },
      {
        id: "202",
        name: "inbill",
        path: "/inbill",
        title: "入库单管理",
      },
      {
        id: "1002",
        path: "-",
        name: "divider2",
        icon: "",
        title: "-"
      },
      {
        id: "203",
        name: "pdbill",
        path: "/pdbill",
        title: "盘点单管理",
      },
      {
        id: "204",
        name: "dbbill",
        path: "/dbbill",
        title: "调货单管理",
      },
      {
        id: "1003",
        path: "-",
        name: "divider3",
        title: "-"
      },
      {
        id: "205",
        name: "viewstock",
        path: "/viewstock",
        title: "商品库存",
      },
      {
        id: "206",
        name: "stockdetail",
        path: "/stockdetail",
        title: "出入库明细表",
      }
    ]
  },
  {
    id: "3",
    name: "report",
    path: "/report",
    title: "数据分析",
    children: [
      {
        id: "301",
        name: "outdetail",
        path: "/outdetail",
        title: "出库对账明细"
      },
      {
        id: "302",
        name: "indetail",
        path: "/indetail",
        title: "入库对账明细"
      },
      {
        id: "303",
        name: "pddetail",
        path: "/pddetail",
        title: "盘点单明细表"
      },
      {
        id: "304",
        name: "dbdetail",
        path: "/dbdetail",
        title: "调货单明细表"
      },
      {
        id: "1004",
        path: "-",
        name: "divider4",
        title: "-"
      },
      {
        id: "305",
        name: "incountgoods",
        path: "/incountgoods",
        title: "按商品统计入库"
      },
      {
        id: "306",
        name: "incountunit",
        path: "/incountunit",
        title: "按往来单位统计入库"
      },
      {
        id: "307",
        name: "incountemp",
        path: "/incountemp",
        title: "按经手人统计入库"
      },
      {
        id: "1005",
        path: "-",
        name: "divider5",
        title: "-"
      },
      {
        id: "308",
        name: "outcountgoods",
        path: "/outcountgoods",
        title: "按商品统计出库"
      },
      {
        id: "309",
        name: "outcountunit",
        path: "/outcountunit",
        title: "按往来单位统计出库"
      },
      {
        id: "310",
        name: "outcountemp",
        path: "/outcountemp",
        title: "按经手人统计出库"
      },
      {
        id: "1006",
        path: "-",
        name: "divider6",
        title: "-"
      },
      {
        id: "311",
        name: "lr",
        path: "/lr",
        title: "商品利润"
      }
    ]
  },
  {
    id: "4",
    name: "sys",
    path: "/sys",
    title: "系统管理",
    children: [
      {
        id: "409",
        path: "/company",
        name: "company",
        title: "单位信息"
      },
      {
        id: "401",
        path: "/sys",
        name: "sys",
        title: "参数设置"
      },
      {
        id: "1007",
        path: "-",
        name: "divider7",
        title: "-"
      },
      {
        id: "402",
        path: "/role",
        name: "role",
        title: "角色权限"
      },
      {
        id: "403",
        path: "/user",
        name: "user",
        title: "操作员管理"
      },
      {
        id: "404",
        path: "/password",
        name: "password",
        title: "修改密码"
      },
      {
        id: "1008",
        path: "-",
        name: "divider8",
        title: "-"
      },
      {
        id: "405",
        path: "/default",
        name: "default",
        title: "默认值管理"
      },
      {
        id: "406",
        path: "/clear",
        name: "clear",
        title: "清除数据"
      },
      // {
      //     id: "407",
      //     path: "/printset",
      //     name: "printset",
      //     title: "网页打印设置"
      // },
      {
        id: "1009",
        path: "-",
        name: "divider8",
        title: "-"
      },
      {
        id: "411",
        path: "/help",
        name: "help",
        title: "使用引导"
      },
      {
        id: "408",
        path: "/closeall",
        name: "closeall",
        title: "关闭所有窗口"
      },
      {
        id: "410",
        path: "/out",
        name: "out",
        title: "安全退出"
      },

    ]
  },
]



// WEBPACK FOOTER //
// ./src/components/menu.js